<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.too_expensive.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.too_expensive.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container" [class.display-downsell]="displayDownsellSolution()">
        <tlc-churn-flow-solution-card
          [iconVariant]="speakWithSpecialist.iconVariant"
          [title]="speakWithSpecialist.title"
          [subtitle]="speakWithSpecialist.subtitle"
          [incentives]="speakWithSpecialist.incentives"
        >
          <div class="actions">
            <rt-button variant="tertiary" (click)="speakToASpecialist()">
              <rt-icon name="open-in-new" />
              <span>{{ speakWithSpecialist.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>
        @if (displayDownsellSolution()) {
          <tlc-churn-flow-solution-card
            [iconVariant]="switchToLowerPlan.iconVariant"
            [title]="switchToLowerPlan.title"
            [subtitle]="switchToLowerPlan.subtitle"
            [incentives]="switchToLowerPlan.incentives"
          >
            <div class="actions">
              <rt-button variant="tertiary" (click)="navigateToPlanPicker()">
                <rt-icon name="open-in-new" />
                <span>{{ switchToLowerPlan.ctaText }}</span>
              </rt-button>
            </div>
          </tlc-churn-flow-solution-card>
        }
        <!-- TODO: Commented out at the moment since we're waiting for a proper action here. -->
        <!--        <tlc-churn-flow-solution-card-->
        <!--          [iconVariant]="saveMoreByConsolidating.iconVariant"-->
        <!--          [title]="saveMoreByConsolidating.title"-->
        <!--          [subtitle]="saveMoreByConsolidating.subtitle"-->
        <!--          [incentives]="saveMoreByConsolidating.incentives"-->
        <!--        >-->
        <!--          <div class="actions">-->
        <!--            <rt-button variant="tertiary" (click)="askAboutConsolidation()">-->
        <!--              <rt-icon name="open-in-new" />-->
        <!--              <span>{{ saveMoreByConsolidating.ctaText }}</span>-->
        <!--            </rt-button>-->
        <!--          </div>-->
        <!--        </tlc-churn-flow-solution-card>-->
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
